// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_lottie-web_build_player_lottie_js":"ba33845cf47f3b4c","shared_utilities_integration_ts":"8996752e36924cda","node_modules_xlsx_xlsx_mjs":"3e21ba7cf6c6ea90","node_modules_angular_fire_node_modules_firebase_compat_analytics_dist_esm_index_esm_js":"8fa9e02364d7fcae"}[chunkId] + ".js";
};